import axios from "axios";
import { API_BASE_URL_AUTH, API_BASE_MOCKUP_URL } from "configs/AppConfig";
import { signOutSuccess } from "store/slices/authSlice";
import store from "../store";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { notification } from "antd";
import LoginPage from "../views/auth-views/authentication/login";

const unauthorizedCode = [400, 401, 403];

const serviceAuth = axios.create({
  baseURL: API_BASE_URL_AUTH,
  timeout: 60000,
  mode: "no-cors",
  credentials: "include",
  withCredentials: false,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Content-Type": "application/json",
    Accept: "application/json",
    data: {},
  },
});

//Config
const TOKEN_PAYLOAD_KEY = "authorization";

//Handler Redirect to Login
// const redirectToLogin = () => {
//   window.location.href = LoginPage;
// };

// API Request interceptor
serviceAuth.interceptors.request.use(
  (config) => {
    console.log("🚀 ~ config:", config);

    config.headers.common["Accept"] = "application/json";

    const jwtToken = localStorage.getItem(AUTH_TOKEN);
    console.log("🚀 ~ jwtToken:", jwtToken);
    if (jwtToken) {
      // Set the Authorization header with the JWT token
      config.headers[TOKEN_PAYLOAD_KEY] = "Bearer " + jwtToken;
    }
    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

// API respone interceptor
serviceAuth.interceptors.response.use(
  (response) => {
    console.log("🚀 ~ response:", response);

    // Remove token and redirect
    // if (unauthorizedCode.includes(response.status)) {
    //   console.log("🚀 ~ response.status:", response.status);
    //   notification.error({
    //     message: "Authentication Fail",
    //     description: "Please login again",
    //   });
    //   localStorage.removeItem(AUTH_TOKEN);
    //   store.dispatch(signOutSuccess());
    // }

    // if (response.status === 404) {
    //   console.log("🚀 ~ response.status:", response.status);
    //   notification.error({
    //     message: "Error",
    //     description: "Not Found",
    //   });
    // }

    // if (response.status === 500) {
    //   console.log("🚀 ~ response.status:", response.status);
    //   notification.error({
    //     message: "Error",
    //     description: "Internal Server Error",
    //   });
    // }

    // if (response.status === 508) {
    //   console.log("🚀 ~ response.status:", response.status);
    //   notification.error({
    //     message: "Error",
    //     description: "Time Out",
    //   });
    // }

    return response;
  },
  (error) => {
    console.error("🚀 ~ error:", error);
    console.error("🚀 ~ error.response:", error.response);

    // Do something with other response errors
    notification.error({
      message: error.response.status,
      description: error.response.data.message,
      duration: 5,
    });

    // store.dispatch(signOutSuccess());

    // setTimeout(() => {
    //   redirectToLogin();
    //   localStorage.removeItem(AUTH_TOKEN);
    //   localStorage.removeItem(USERID);
    //   localStorage.removeItem(USERNAME);
    //   localStorage.removeItem(MODE);
    //   localStorage.removeItem(BRANCH);
    // }, 500);

    // let notificationParam = {
    //   message: "",
    // };

    // // Remove token and redirect
    // if (unauthorizedCode.includes(error.response.status)) {
    //   notificationParam.message = "Authentication Fail";
    //   notificationParam.description = "Please login again";
    //   localStorage.removeItem(AUTH_TOKEN);
    //   store.dispatch(signOutSuccess());
    // }

    // if (error.response.status === 404) {
    //   notificationParam.message = "Not Found";
    // }

    // if (error.response.status === 500) {
    //   notificationParam.message = "Internal Server Error";
    // }

    // if (error.response.status === 508) {
    //   notificationParam.message = "Time Out";
    // }

    // notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default serviceAuth;
